import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { DataSourceEffects } from './data-source/data-source.effects';
import { DataSourceNamespace, DataSourceReducer } from './data-source/data-source.store';
import { DataSourceListEffects } from './data-source-list/data-source-list.effects';
import {
  DataSourceListNamespace,
  DataSourceListReducer,
} from './data-source-list/data-source-list.store';
import { FilterGroupEffects } from './filter-group/filter-group.effects';
import {
  ViewFilterGroupNamespace,
  ViewFilterGroupReducer,
} from './filter-group/filter-group.store';
import { GroupsEffects } from './groups/groups.effects';
import { ViewGroupsNamespace, ViewGroupsReducer } from './groups/groups.store';
import { InputOptionsEffects } from './input-options/input-options.effects';
import { InputOptionsNamespace, InputOptionsReducer } from './input-options/input-options.store';
import { RecordsEffects } from './records/records.effects';
import { ViewRecordsNamespace, ViewRecordsReducer } from './records/records.store';
import { SwimlaneEffects } from './swimlanes/swimlanes.effects';
import { ViewSwimlaneNamespace, ViewSwimlaneReducer } from './swimlanes/swimlanes.store';
import { ViewEffects } from './view/view.effects';
import { ViewNamespace, ViewReducer } from './view/view.store';
import { ViewCountersEffects } from './view-counters/view-counters.effects';
import { ViewCountersNamespace, ViewCountersReducer } from './view-counters/view-counters.store';
import { ViewListEffects } from './view-list/view-list.effects';
import { ViewListNamespace, ViewListReducer } from './view-list/view-list.store';

export const provideDataSourceListState = provideState(
  DataSourceListNamespace,
  DataSourceListReducer,
);
export const provideDataSourceListEffects = provideEffects(DataSourceListEffects);

export const provideDataSourceState = provideState(DataSourceNamespace, DataSourceReducer);
export const provideDataSourceEffects = provideEffects(DataSourceEffects);

export const provideFilterOptionsState = provideState(InputOptionsNamespace, InputOptionsReducer);
export const provideFilterOptionsEffects = provideEffects(InputOptionsEffects);

export const provideViewState = provideState(ViewNamespace, ViewReducer);
export const provideViewEffects = provideEffects(ViewEffects);

export const provideViewListState = provideState(ViewListNamespace, ViewListReducer);
export const provideViewListEffects = provideEffects(ViewListEffects);

export const provideViewGroupsState = provideState(ViewGroupsNamespace, ViewGroupsReducer);
export const provideViewGroupsEffects = provideEffects(GroupsEffects);

export const provideViewSwimlaneState = provideState(ViewSwimlaneNamespace, ViewSwimlaneReducer);
export const provideViewSwimlaneEffects = provideEffects(SwimlaneEffects);

export const provideViewRecordsState = provideState(ViewRecordsNamespace, ViewRecordsReducer);
export const provideViewRecordsEffects = provideEffects(RecordsEffects);

export const provideViewCountersState = provideState(ViewCountersNamespace, ViewCountersReducer);
export const provideViewCountersEffects = provideEffects(ViewCountersEffects);

export const provideViewFilterGroupState = provideState(
  ViewFilterGroupNamespace,
  ViewFilterGroupReducer,
);
export const provideViewFilterGroupEffects = provideEffects(FilterGroupEffects);

@NgModule({
  imports: [
    StoreModule.forFeature(ViewRecordsNamespace, ViewRecordsReducer),
    EffectsModule.forFeature([RecordsEffects]),
  ],
})
export class ViewRecordsDataModule {}

export const viewsDataProviders = [
  provideDataSourceListState,
  provideDataSourceListEffects,
  provideDataSourceState,
  provideDataSourceEffects,
  provideFilterOptionsState,
  provideFilterOptionsEffects,
  provideViewState,
  provideViewEffects,
  provideViewListState,
  provideViewListEffects,
  provideViewGroupsState,
  provideViewGroupsEffects,
  provideViewSwimlaneState,
  provideViewSwimlaneEffects,
  provideViewRecordsState,
  provideViewRecordsEffects,
  provideViewCountersState,
  provideViewCountersEffects,
  provideViewFilterGroupState,
  provideViewFilterGroupEffects,
];
